const srcSetMapToAttribute = (srcSet) => {
    if (srcSet) {
        return Object.keys(srcSet)
            .reduce((acc, key) => {
                acc.push(
                    `${srcSet[key]} ${key}`
                );

                return acc;
            }, [])
            .join(', ');
    }

    return '';
};

export default srcSetMapToAttribute;
